import close from "./close";
import { useCrossPlatformRootTag } from "../../context/CrossPlatformRootTagContext";

/**
 * Hook that returns a close function with the current RootTag context.
 * Use this instead of manually passing rootTag to close().
 */
export function useClose(): () => Promise<void | null> {
  const rootTag = useCrossPlatformRootTag();
  return async () => {
    try {
      return await close(rootTag);
    } catch (error: unknown) {
      // Handle race condition where React Native view was unmounted but fragment still exists
      if (error instanceof Error && "code" in error && error.code === "VIEW_UNMOUNTED") {
        console.error(
          `React Native view lifecycle race condition detected in close(), rootTag: ${rootTag}`,
          error,
        );

        return null;
      }

      // Re-throw other errors
      throw error;
    }
  };
}
